(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vg-model-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vgmf]').forEach(function (root) {
    if (root.dataset.vgmfReady) return;
    root.dataset.vgmfReady = '1';
    var section = root.closest('.vgmf');
    var C = [];
    try { C = JSON.parse(section.querySelector('[data-vgmf-catalog]').textContent) || []; } catch (e) { return; }
    C = C.filter(function (p) { return p.code; });
    var FAM = { RW4006: 'Wayfarer', RW4008: 'Wayfarer', RW4012: 'Wayfarer', RW4009: 'Headliner', RW4009F: 'Headliner', RW4013: 'Headliner', RW4013F: 'Headliner', RW4010: 'Skyler', RW4014: 'Skyler', RW7001: 'Blayzer', RW7002: 'Scriber' };
    C.forEach(function (p) { p.meta = p.code.indexOf('RW') === 0; p.family = FAM[p.code] || p.name; });

    var q = root.querySelector('[data-vgmf-q]'), sugg = root.querySelector('[data-vgmf-sugg]'), res = root.querySelector('[data-vgmf-res]'), form = root.querySelector('[data-vgmf-form]');
    var MODEL_RE = /R[WB][0-9]{3,4}[A-Z]{0,2}/;
    var norm = function (s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9 ]/g, ' '); };
    var byCode = {}; C.forEach(function (p) { byCode[p.code] = p; });
    var sizesOf = function (p) { return Object.keys(p.sizes).filter(function (k) { return /^[0-9]+$/.test(k) && +k > 0; }).map(Number).sort(); };
    var pdp = function (p, size) { var id = size && (p.sizes[size + 'p'] || p.sizes[size]); if (!id) { var k = Object.keys(p.sizes)[0]; id = p.sizes[k]; } return '/products/' + p.handle + (id ? '?variant=' + id : ''); };
    var label = function (p) { return (p.meta ? 'Ray-Ban Meta ' : 'Ray-Ban ') + p.name + ' · ' + p.code + (p.gen2 ? ' (Gen 2)' : ''); };
    var arrow = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var active = -1, items = [];

    function parse(v) {
      var n = norm(v);
      var m = n.replace(/\s+/g, '').match(MODEL_RE);
      var code = m ? m[0] : '';
      var rest = code ? n.replace(new RegExp(code.split('').join('\\s*')), ' ') : n;
      var sm = rest.match(/\b([3-7][0-9])\b/);
      return { code: code, size: sm ? +sm[1] : 0, raw: n.trim() };
    }
    function matches(v) {
      var n = norm(v).trim(); if (n.length < 2) return [];
      var compact = n.replace(/\s+/g, ''), p = parse(v);
      var nameTerm = n.replace(/\b[0-9]+\b/g, ' ').replace(/\s+/g, ' ').trim();
      return C.filter(function (x) {
        if (p.code && x.code.indexOf(p.code) === 0) return true;
        if (x.code.indexOf(compact) === 0) return true;
        if (nameTerm.length < 2) return false;
        return x.name.toUpperCase().indexOf(nameTerm) !== -1 || x.family.toUpperCase().indexOf(nameTerm) !== -1;
      }).sort(function (a, b) { return (b.code.indexOf(compact) === 0) - (a.code.indexOf(compact) === 0) || a.code.localeCompare(b.code); }).slice(0, 6);
    }
    function renderSugg() {
      items = matches(q.value); active = -1;
      if (!items.length) { sugg.hidden = true; q.setAttribute('aria-expanded', 'false'); return; }
      sugg.innerHTML = items.map(function (p, i) {
        var s = sizesOf(p);
        return '<li role="option" id="' + sugg.id + '-' + i + '" data-i="' + i + '"><img src="' + p.img + '" alt="" loading="lazy"><div><div class="sc">' + p.code + (p.gen2 ? ' <span class="ss">· Gen 2</span>' : '') + '</div><div class="sn">' + (p.meta ? 'Ray-Ban Meta ' : 'Ray-Ban ') + p.name + '</div></div><span class="ss">' + (s.length ? s.join(' / ') + ' mm' : '') + '</span></li>';
      }).join('');
      sugg.hidden = false; q.setAttribute('aria-expanded', 'true');
    }
    function track(state) {
      try {
        var d = parse(q.value), payload = { entered_model: d.code, entered_size: d.size, result: state };
        document.dispatchEvent(new CustomEvent('vg:model-finder', { detail: payload }));
        if (window.dataLayer) window.dataLayer.push({ event: 'vg_model_finder', vg_model: d.code, vg_size: d.size, vg_result: state });
      } catch (e) {}
    }
    function show(state, html) {
      res.hidden = false; res.dataset.state = state;
      res.innerHTML = html + '<button type="button" class="x" aria-label="Close"><svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>';
      res.querySelector('.x').addEventListener('click', function () { res.hidden = true; });
      res.classList.remove('show'); void res.offsetWidth; res.classList.add('show');
      track(state);
    }
    function resolve(p, size) {
      var s = sizesOf(p), pic = '<img src="' + p.img + '" alt="">';
      if (!s.length || (size && s.indexOf(size) !== -1) || (!size && s.length === 1)) {
        var sz = size || s[0] || 0;
        return show('ok', pic + '<div><div class="rk">We cut these</div><h3>' + label(p) + (sz ? ' · ' + sz + ' mm' : '') + '</h3><p>Cut to the original lens profile for your ' + p.code + ' — a drop-in fit, prescription or non-prescription.</p><a class="go" href="' + pdp(p, sz) + '">Shop ' + p.code + (sz ? ' ' + sz + ' mm' : '') + ' lenses ' + arrow + '</a></div>');
      }
      if (!size) {
        return show('ok', pic + '<div><div class="rk">We cut these — pick your width</div><h3>' + label(p) + '</h3><p>The second number on your arm is the lens width. Which is yours?</p><div class="sizes">' + s.map(function (x) { return '<a href="' + pdp(p, x) + '">' + x + ' mm</a>'; }).join('') + '</div></div>');
      }
      var sib = C.filter(function (x) { return x !== p && x.family === p.family && x.meta === p.meta && sizesOf(x).indexOf(size) !== -1; })[0];
      if (sib) {
        return show('warn', '<img src="' + sib.img + '" alt=""><div><div class="rk">Check the code again</div><h3>' + p.code + ' is cut at ' + s.join(' / ') + ' mm — a ' + size + ' mm ' + p.family + ' is the ' + sib.code + (sib.gen2 ? ' (Gen 2)' : '') + '</h3><p>Same frame family, different housing. If your arm reads ' + sib.code + ', these are yours:</p><a class="go" href="' + pdp(sib, size) + '">Shop ' + sib.code + ' ' + size + ' mm lenses ' + arrow + '</a></div>');
      }
      return show('warn', pic + '<div><div class="rk">Width doesn’t match</div><h3>We cut ' + p.code + ' at ' + s.join(' / ') + ' mm, not ' + size + '</h3><p>Double-check the second number on the arm. If it really says ' + size + ', <a href="/pages/contact">send us a photo</a> and we’ll confirm before you order.</p><div class="sizes">' + s.map(function (x) { return '<a href="' + pdp(p, x) + '">Use ' + x + ' mm</a>'; }).join('') + '</div></div>');
    }
    function miss(d) {
      var what = d.code || d.raw;
      var mail = 'mailto:support@visionglobaldirect.com?subject=' + encodeURIComponent('Custom lenses for ' + what) + '&body=' + encodeURIComponent('Hi Vision Global,\n\nMy frame marking reads: ' + what + '\nPlease cut lenses for it.\n\n');
      show('miss', '<div style="grid-column:1/-1"><div class="rk">Not listed yet — we can still cut it</div><h3>We cut lenses for any frame</h3><p>' + (d.code ? '<strong>' + d.code + '</strong> isn’t in the shop yet, but our lab can make it. ' : '') + 'Order through our custom lens page, or email us your model code and we’ll get it made for you.</p><div class="acts"><a class="go" href="/products/custom-lenses">Order custom lenses ' + arrow + '</a><a class="go go--alt" href="' + mail + '">Email support@visionglobaldirect.com</a></div></div>');
    }
    var err = root.querySelector('[data-vgmf-err]'), errTimer;
    function showErr() {
      err.innerHTML = 'Enter your model number first.<span class="vgmf-err-sub">It’s printed inside your temple arm — like RW4008.</span>';
      err.hidden = false;
      clearTimeout(errTimer); errTimer = setTimeout(function () { err.hidden = true; }, 6000);
    }
    function submit() {
      sugg.hidden = true; q.setAttribute('aria-expanded', 'false');
      var d = parse(q.value);
      if (!d.raw) { showErr(); q.focus(); return; }
      err.hidden = true;
      var p = byCode[d.code];
      if (!p && d.code) {
        var cands = C.filter(function (x) { return x.code.indexOf(d.code) === 0 || d.code.indexOf(x.code) === 0; });
        if (cands.length === 1) p = cands[0];
        else if (cands.length > 1) p = cands.filter(function (x) { return !d.size || sizesOf(x).indexOf(d.size) !== -1; })[0] || cands[0];
      }
      if (!p && !d.code) {
        var byName = matches(q.value);
        if (byName.length > 1 && d.size) {
          var narrowed = byName.filter(function (x) { return sizesOf(x).indexOf(d.size) !== -1; });
          if (narrowed.length) byName = narrowed;
        }
        if (byName.length === 1) p = byName[0];
        else if (byName.length > 1) return choose(byName, d);
      }
      if (!p) return miss(d);
      resolve(p, d.size);
    }
    function choose(list, d) {
      var fam = list[0].family;
      var same = list.every(function (x) { return x.family === fam; });
      var rows = list.slice(0, 6).map(function (x) {
        var s = sizesOf(x);
        return '<a href="' + pdp(x, d.size && s.indexOf(d.size) !== -1 ? d.size : s[0]) + '">' + x.code + (x.gen2 ? ' · Gen 2' : '') + (s.length ? ' · ' + s.join(' / ') + ' mm' : '') + '</a>';
      }).join('');
      show('ok', '<div style="grid-column:1/-1"><div class="rk">A few models match — check your arm</div><h3>Which ' + (same ? fam : 'model') + ' is yours?</h3><p>The code printed inside the temple arm tells them apart:</p><div class="sizes">' + rows + '</div></div>');
    }
    function pick(p) { var d = parse(q.value); q.value = p.code + (d.size ? ' ' + d.size : ''); sugg.hidden = true; resolve(p, d.size); }

    q.addEventListener('pointerdown', function () { err.hidden = true; clearTimeout(errTimer); });
    q.addEventListener('input', function () { err.hidden = true; clearTimeout(errTimer); renderSugg(); });
    q.addEventListener('keydown', function (e) {
      if (sugg.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        Array.prototype.forEach.call(sugg.children, function (li, i) { li.setAttribute('aria-selected', i === active); });
        q.setAttribute('aria-activedescendant', sugg.id + '-' + active);
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); pick(items[active]); }
      else if (e.key === 'Escape') { sugg.hidden = true; }
    });
    var howto = root.querySelector('[data-vgmf-howto]');
    var howtoOpen = root.querySelector('[data-vgmf-howto-open]');
    if (howto && howtoOpen && typeof howto.showModal === 'function') {
      howtoOpen.addEventListener('click', function () { err.hidden = true; howto.showModal(); });
      howto.addEventListener('click', function (e) {
        if (e.target === howto) { howto.close(); return; }
        var c = e.target.closest('[data-vgmf-howto-close]');
        if (c) { howto.close(); if (c.hasAttribute('data-vgmf-howto-focus')) q.focus(); }
      });
    } else if (howtoOpen) { howtoOpen.hidden = true; }
    var chatBtn = root.querySelector('[data-vgmf-chat]');
    if (chatBtn) chatBtn.addEventListener('click', function () {
      var sc = document.querySelector('shopify-chat');
      if (sc) {
        try { if (typeof sc.openFromActivator === 'function') { sc.openFromActivator(); return; } } catch (e) {}
        try { if (typeof sc.open === 'function') { sc.open(); return; } } catch (e) {}
        try { var b = sc.shadowRoot && sc.shadowRoot.querySelector('button'); if (b) { b.click(); return; } } catch (e) {}
      }
      window.location.href = '/pages/contact';
    });
    sugg.addEventListener('mousedown', function (e) { var li = e.target.closest('li'); if (li) { e.preventDefault(); pick(items[+li.dataset.i]); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) sugg.hidden = true; });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  });

  } catch(e) { console.error(e); }
})();
})();
